var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('el-menu',{attrs:{"collapse":_vm.collapse,"default-active":_vm.activeItemName,"active-text-color":"#ff4f4f","background-color":"#304156","text-color":"#bfcbd9"},on:{"select":_vm.go}},[_vm._l((_vm.items),function(item,i){return [_c('menu-item',{key:i,attrs:{"item":item,"root":true}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }